import {validateCusNo, validatePassword} from "../util/validators.js";

import ChangePasswordPage from "../components/ChangePasswordPage.jsx";
import {connect} from "react-redux";
import {createLocalization} from "../util/localization.jsx";
import {getQueryParameters} from "../util/location.js";
import {setCurrentLanguage} from "../actions/userSettings";
import {setNewPassword} from "../actions/authentication.js";

const mapStateToProps = (state, ownProps) => {
    const queryParameters = getQueryParameters(ownProps.location.search);
    const token = decodeURIComponent(ownProps.match.params.token);

    return {
        authentication: state.authentication,
        clientOutOfDate: state.view.clientOutOfDate,
        currentLanguage: state.userSettings ? state.userSettings.currentLanguage : 0,
        deviceType: state.view.deviceType,
        downloadingLocalization: state.localization.downloading,
        localization: createLocalization(state),
        loggingIn: state.authentication.loggingIn,
        reasonForFailedLogin: queryParameters.ReasonForLogout ? queryParameters.ReasonForLogout : state.authentication.loginForm.reasonForFailedLogin,
        resetPasswordToken: token,
    };
};

const mapDispatchToProps = {
    setCurrentLanguage,
    setNewPassword,
    validateCusNo,
    validatePassword,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
});


export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ChangePasswordPage);